import { render, staticRenderFns } from "./imDialog.vue?vue&type=template&id=5d78445b&scoped=true&"
import script from "./imDialog.vue?vue&type=script&lang=js&"
export * from "./imDialog.vue?vue&type=script&lang=js&"
import style0 from "./imDialog.vue?vue&type=style&index=0&id=5d78445b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78445b",
  null
  
)

export default component.exports